import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export const useAdminCheck = () => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      const { data: sessionData, error: sessionError } = await supabase.auth.getSession();

      if (sessionError || !sessionData.session) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      const userId = sessionData.session.user.id;

      const { data: adminRow } = await supabase
        .from("Admin")
        .select("user_id")
        .eq("user_id", userId)
        .maybeSingle();

      setIsAdmin(!!adminRow);
      setLoading(false);
    };

    checkAdminStatus();
  }, []);

  return { isAdmin, loading };
};
